/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

export enum EReasonCode {
  VolumeQuote = "D9",
  WrongPricing = "D10",
  Uncompetitive = "D6",
  Clearance = "D3",
  Quality = "D4",
}

export enum EUnitPriceFields {
  UnitPrice = "unitPrice",
  ReasonCode = "reasonCode",
  ReasonNote = "reasonNote",
}

export type TUnitPriceFormData = {
  [key in EUnitPriceFields]?: string;
};

export interface IUnitPriceState {
  unitPrice: number | undefined;
  reasonCode: string | undefined | null;
  reasonNote: string | undefined | null;
}

export interface IUnitPriceFormRef {
  submit: () => Promise<void>;
  getFormData: () => TUnitPriceFormData | null;
  reset: () => void;
}

export interface IUnitPriceFormProps {
  productId?: number;
  unitPriceState?: IUnitPriceState;
  validateAllFieldsOnSubmit?: boolean;
  onFormChange: (updatedUnitPriceState?: IUnitPriceState) => void;
  onSubmit: (data: TUnitPriceFormData) => void;
  onRevertChanges: () => void;
  originalPrice: number;
}
